<app-doctors-dashboard [isConsultant]="true">

</app-doctors-dashboard>